import { useQuery } from '@tanstack/react-query';

import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants';
import { UseFetchEnabledParams } from '@/shared/interfaces';
import { PermissionSistemaPagingRes } from '@/shared/interfaces/erp/administration/grupo-sistema';
import { getUrlParamsFetch } from '@/shared/utils';

const { get } = erpApi();

///* tanStack query
export const useFetchSystemPermissions = ({
  enabled = true,
  params,
}: UseFetchEnabledParams<GetAllPermissionsParams> = {}) => {
  return useQuery({
    queryKey: ['permissions', ...Object.values(params || {})],
    queryFn: () => getAllPermissions(params),
    retry: false,
    enabled: enabled,
  });
};

///* axios
export type GetAllPermissionsParams = {
  page?: number;
  page_size?: number;
  order_by?: string;
  order_up?: boolean;
  search?: string; // nombre

  id?: number; // ID del usuario
  group?: number; // ID del grupo
};

const getAllPermissions = async (
  params?: GetAllPermissionsParams
): Promise<PermissionSistemaPagingRes> => {
  const queryParams = getUrlParamsFetch(params || {});

  const { data } = await get(
    `${urlBackend}api/v1/get-permisos/?${queryParams}`,
    true
  );

  return data as PermissionSistemaPagingRes;
};
